/**
 * @file   src\pages\Messaging.js
 * @brief  This file is responsible for handling messaging/chat screen.
 * @date   June, 2023
 * @author ZCO Engineer
 * @copyright (c) 2023, ZCO
 */

import React, { useState, useEffect } from "react";
import CommonHeader from "../../components/Onboarding/CommonHeader";
import { useSelector } from "react-redux";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import MessageLeftSection from "../../components/Messages/MessageLeftSection";
import {
  decodeParam,
  getLocalStorage,
  loggedInUser,
} from "../../helpers/common";
import { USER_INFO_KEY } from "../../constants/common";
import DirectMessagesRightSection from "../../components/Messages/DirectMessagesRightSection";
import { loginOrSignUp } from "../../helpers/message";
import { getIntroductionDetaisById } from "../../services/introductionService";
import IntroDetails from "../../components/Messages/IntroDetails";
import AgentProfileViewModal from "../../components/Introduction/AgentProfileViewModal";
import SelectDropDown from "../../components/Common/SelectDropDown";
import {
  useNavigate,
  useSearchParams,
  useParams,
  useLocation,
} from "react-router-dom";
import { pageURLs } from "../../constants/v2/pageURLs";
import { getDirectChats } from "../../services/messagesService";
import DirectMessageLeftSection from "../../components/Messages/DirectMessageLeftSection";
import { getUserProfileForDM } from "../../services/v2/agentProfile";

const DirectMessages = (props) => {
  const navigate = useNavigate();
  const [directChats, setDirectChats] = useState([]);
  const [slug, setSlug] = useState("");
  const sessionData = getLocalStorage(USER_INFO_KEY);
  //user's own info
  const userId = _.get(sessionData, "userInfo.userId", "");
  const [selectedIntroductionId, setSelectedIntroductionId] = useState(0);
  const [selectedData, setSelectedData] = useState("");
  const [filter, setFilter] = useState("all");
  const userDetails = loggedInUser();
  const [showViewIntroductionModal, setViewIntroductionModal] = useState(false);
  const handleIntroDetailModal = (modalState) =>
    setViewIntroductionModal(modalState);
  const [introDetails, setIntroDetails] = useState([]);
  const [showProfileModal, setProfileModal] = useState(false);
  const ProfileModalClose = () => setProfileModal(false);
  const [selectedUserId, setSelectedUserId] = useState(0);
  const [isFromMessage, setIsFromMessage] = useState(false);
  const [filterList, setFilterList] = useState([]);

  const [message, setMessages] = useState("");
  const [searchParams, setSearchParams] = useSearchParams();
  const [introIdFromURL, setIntroIDFromURL] = useState(
    searchParams.get("Id") ? decodeParam(searchParams.get("Id")) : null,
  );

  const [userDeleted, setUserDeleted] = useState(false);

  const chatMessages = useSelector((state) => state.unreadCount.chatMessages);
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const chatId = params.get("id");
  const fromDM = location.state?.fromDM;
  const [agentProfile, setAgentProfile] = useState(null);

  //GET SELECTED AGENT DETAILS
  const getAgentDetails = async (slug) => {
    await getUserProfileForDM(slug)
      .then((response) => {
        const responseResult = _.get(response, "result", null);

        if (response.errorCode === 0 && responseResult) {
          setAgentProfile(responseResult);
        } else {
          console.log("Something went wrong");
        }
      })
      .catch((err) => {
        navigate(pageURLs.directMessages);
        console.log("Error", err);
      });
  };
  console.log(useParams());
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const chatId = params.get("id");
    if (chatId) {
      getAgentDetails(chatId);
    }
  }, [location.search, getUserProfileForDM]);

  useEffect(() => {
    let email = _.get(userDetails, "userInfo.email", null);
    let login = loginOrSignUp(email);

    if (!login) {
      navigate(pageURLs.home);
    }
  }, []);
  const handleWantAdSelection = async (msgData) => {
    if (msgData?.introductionId) {
      setSelectedIntroductionId(msgData?.introductionId);
      setSelectedData(msgData);
      setIntroIDFromURL(null);
    }
  };

  const handleFilter = (e) => {
    setFilter(e.value);
  };
  useEffect(() => {
    getDirectChatsLeft();
  }, [chatId]);

  const handleFilterValue = (value) => {
    if (filterList && value) {
      const filterValue = filterList.filter(function (lst) {
        return lst.value === value;
      });
      return filterValue;
    }
    return null;
  };

  const updateLastMessage = (chatId, lastMessage) => {
    const chat = directChats.find((item) => item.id === chatId);
    if (chat) {
      chat.lastMessage = lastMessage;
      chat.lastMessageAt = new Date().getTime();
      setDirectChats([...directChats]);
    } else {
      getDirectChatsLeft();
    }
  };
  useEffect(() => {
    let fetchedMessages = chatMessages?.payload;
    let orderd = [];
    if (fetchedMessages) {
      let assignedToMe = fetchedMessages?.filter(
        (item) =>
          item.wantAdCreatedId == userId &&
          item.isaccepted == true &&
          item.isdeleted == false,
      );
      let assignedByMe = fetchedMessages?.filter(
        (item) =>
          item.inventroyCreatedId == userId &&
          item.isaccepted == true &&
          item.isdeleted == false,
      );

      orderd = [...assignedToMe, ...assignedByMe];

      let allCountLabel =
        orderd && orderd.length > 0
          ? "All conversations (" + orderd.length + ")"
          : "All conversations";
      let sentByMeCountLabel =
        assignedByMe && assignedByMe.length > 0
          ? "Introductions sent (" + assignedByMe.length + ")"
          : "Introductions sent";
      let sentToMeCountLabel =
        assignedToMe && assignedToMe.length > 0
          ? "Introduced to me (" + assignedToMe.length + ")"
          : "Introduced to me";

      const options = [
        { value: "all", label: allCountLabel },
        { value: "intro_sent", label: sentByMeCountLabel },
        { value: "intro_to_me", label: sentToMeCountLabel },
      ];
      setFilterList(options);

      if (filter == "intro_to_me") {
        const doEmptyAction = assignedToMe.every((o) => o.createdat);
        if (doEmptyAction) {
          orderd = assignedToMe.sort((a, b) => b.createdat - a.createdat);
          setMessages(orderd);
          setSelectedData(orderd[0]);
          setSelectedIntroductionId(orderd[0]?.introductionId);
        }
      } else if (filter == "intro_sent") {
        const doEmptyAction = assignedByMe.every((o) => o.createdat);
        if (doEmptyAction) {
          orderd = assignedByMe.sort((a, b) => b.createdat - a.createdat);
          setMessages(orderd);
          setSelectedData(orderd[0]);
          setSelectedIntroductionId(orderd[0]?.introductionId);
        }
      } else {
        const doEmptyAction = orderd.every((o) => o.createdat);
        if (doEmptyAction) {
          let orderdNew = orderd.sort((a, b) => b.createdat - a.createdat);
          setMessages(orderdNew);
          setSelectedData(orderdNew[0]);
          setSelectedIntroductionId(orderdNew[0]?.introductionId);
        }
      }
    } else {
      const options = [
        { value: "all", label: 0 },
        { value: "intro_sent", label: 0 },
        { value: "intro_to_me", label: 0 },
      ];
      setFilterList(options);
      setMessages([]);
      setSelectedData(null);
      setSelectedIntroductionId(null);
    }
  }, [chatMessages, filter]);
  /**
   * To get introduction details
   * @param {*} introductionId
   */
  const getIntroductionDetails = async (introductionId) => {
    if (introductionId) {
      await getIntroductionDetaisById(introductionId)
        .then((response) => {
          const responseResult = _.get(response, "result", null);
          if (response.errorCode === 0 && responseResult) {
            setIntroDetails(responseResult[0]);
            handleIntroDetailModal(true);
          } else {
            console.log("Something went wrong");
          }
        })
        .catch((err) => {
          console.log("Error", err);
        });
    }
  };
  console.log("directChats", directChats);
  const getDirectChatsLeft = async () => {
    await getDirectChats()
      .then((response) => {
        const responseResult = _.get(response, "result", null);
        setDirectChats(responseResult);
        setSlug(responseResult?.slug);
        if (response.errorCode === 0 && responseResult) {
        } else {
          console.log("Something went wrong");
        }
      })
      .catch((err) => {
        console.log("Error", err);
      });
  };

  const ViewProfile = (agentId, isFromMessageScreen = false) => {
    handleIntroDetailModal(false);
    setIsFromMessage(isFromMessageScreen);
    setSelectedUserId(agentId);
    setProfileModal(true);
  };

  const closeAgentModal = (isFromMessage) => {
    if (!isFromMessage) {
      handleIntroDetailModal(true);
    }
    setProfileModal(false);
  };

  return (
    <>
      <div className="outer-wrap position-relative  min-vh-100 agent-no-login">
        <CommonHeader />
        <div className="m-0">
          <div className="left-sidebar p-0">{/* <Sidebar /> */}</div>
          <div className="main-content p-0 agent-no-login-content">
            <div className="msg-tab">
              <Tabs
                defaultActiveKey="direct-message"
                id="uncontrolled-tab-example"
                className="mb-3"
                onSelect={(key) => {
                  if (key === "messages") {
                    navigate("/messages");
                  } else {
                    navigate("/direct-messages");
                  }
                }}
              >
                <Tab eventKey="messages" title="Introduction Messages">
                  Introduction Messgaes
                </Tab>
                <Tab eventKey="direct-message" title="Direct Message">
                  <div className="row msg-height">
                    <div className="col-12 col-md-6 pe-md-3 col-lg-4 pe-lg-3 col-xl-4 pe-xl-2 mb-4 mb-sm-4 mb-md-0 ">
                      <div className="ad-strengthen-wrap strengthen-adjust-wrap mh-490 pe-0 ps-0 pt-0 pb-2">
                        <div className="messaging-top-header pb-12 pl-16 pr-16 pt-4">
                          <h3>Messages</h3>
                          {/* {!introductionsArray.length > 0 && !fromDM && (
                      <div className="messaging-select-wrap">
                        <SelectDropDown
                          id="multi3444"
                          name="colors33"
                          options={filterList}
                          className="basic-single-inventory bg-color-fix message-custom-width mb-0"
                          classNamePrefix="select"
                          placeholder="Select"
                          defaultValue={filterList[0]}
                          value={handleFilterValue(filter)}
                          onChange={(e) => {
                            handleFilter(e);
                          }}
                          styles={{
                            dropdownIndicator: (provided, state) => ({
                              ...provided,
                              transform:
                                state.selectProps.menuIsOpen &&
                                "rotate(180deg)",
                            }),
                          }}
                          errorClass="error-msg error-msg-height"
                        />
                      </div>
                    )} */}
                        </div>

                        <DirectMessageLeftSection messages={directChats} />
                      </div>
                    </div>
                    <DirectMessagesRightSection
                      updateLastMessage={updateLastMessage}
                      userId={userId}
                      agentProfile={agentProfile}
                    />
                  </div>
                </Tab>
              </Tabs>
            </div>
          </div>
        </div>
      </div>
      <IntroDetails
        details={introDetails}
        show={showViewIntroductionModal}
        onHide={handleIntroDetailModal}
        ViewProfileModal={(agentId) => {
          ViewProfile(agentId);
        }}
        userDeleted={userDeleted}
      />

      <AgentProfileViewModal
        show={showProfileModal}
        onHide={ProfileModalClose}
        userId={selectedUserId}
        isFromMessage={isFromMessage}
        onClose={(isFromMessage) => {
          closeAgentModal(isFromMessage);
        }}
      />
    </>
  );
};

export default DirectMessages;
